"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeToggler = void 0;
var _react = _interopRequireDefault(require("react"));
var _ThemeContext = require("../ThemeContext");
require("./ThemeToggler.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ThemeToggler = exports.ThemeToggler = function ThemeToggler() {
  var _useTheme = (0, _ThemeContext.useTheme)(),
    theme = _useTheme.theme,
    changeTheme = _useTheme.changeTheme;
  var isLight = theme === 'light';
  var label = isLight ? 'Dark' : 'Light';
  var cls = ['theme-toggle', isLight && 'theme-toggle--toggled'].filter(Boolean).join(' ');
  var isHomePage = window.location.pathname === '/';
  var iconColor = isHomePage ? 'white' : 'currentColor';
  var viewBox = isHomePage ? '0 3 32 32' : '0 0 32 32';
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: cls,
    "aria-label": label,
    label: label,
    onClick: function onClick() {
      return changeTheme(isLight ? 'dark' : 'light');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, label), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22px",
    height: "22px",
    fill: iconColor,
    "aria-hidden": "true",
    strokeLinecap: "round",
    className: "theme-toggle__icon",
    viewBox: viewBox
  }, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "theme-toggle__icon__cutout"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0-5h30a1 1 0 0 0 9 13v24H0Z"
  })), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "background",
    cx: "16",
    cy: "16",
    r: "16",
    fill: "currentColor"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#theme-toggle__icon__cutout)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "9.34"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: iconColor,
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 5.5v-4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 30.5v-4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.5 16h4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.5 16h4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.4 8.6 2.8-2.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m5.7 26.3 2.9-2.9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m5.8 5.8 2.8 2.8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.4 23.4 2.9 2.9"
  })))));
};